module.exports = __webpack_public_path__ + "static/img/openapp-small.0dad4c16.svg";